module.exports = __webpack_public_path__ + "img/brandstory_img3.b31859f6.png";